import { toastr } from 'react-redux-toastr';

import ConvertToApplicantModal from '../../../containers/ConvertToApplicantModal';
// eslint-disable-next-line max-len
import { MODAL_MODES } from '../../../containers/ConvertToApplicantModal/constants';
import { reloadPage } from '../../../utils/navigation-helpers';
import { useEditAffordableWaitlist } from '../hooks';

// The wizard collects and validates; this owns only the request and what
// happens either side of it.
const EditWaitlist = ({
  organizationId,
  propertyId,
  applicationId,
  floorPlans,
  open,
  handleClose,
  onSuccess,
}) => {
  const { mutate: editMutate, isLoading: isSubmitting } =
    useEditAffordableWaitlist({
      organizationId,
      propertyId,
      options: {
        onSuccess: () => {
          toastr.success('Success', 'Waitlist details updated successfully');
          handleClose();
          onSuccess();
        },
        // The route answers a refusal as Boom.badRequest, so the message is
        // the backend's own and displayable. A 400 here doubles as a
        // staleness guard (e.g. someone denied the household in another tab
        // while this was open) — reload instead of leaving the form open to
        // retry against a record that no longer matches what the backend
        // just refused.
        onError: (e) => {
          toastr.error('Error', e?.message ?? e);
          if (e?.statusCode === 400) {
            reloadPage();
          }
        },
      },
    });

  // Unmounting while closed is what discards a half-finished edit: the wizard
  // holds the form state, and it re-seeds from the record on the next open.
  if (!open) return null;

  return (
    <ConvertToApplicantModal
      open
      mode={MODAL_MODES.EDIT}
      applicationId={applicationId}
      floorPlans={floorPlans}
      onClose={handleClose}
      onSubmit={(payload) => editMutate({ applicationId, payload })}
      isSubmitting={isSubmitting}
    />
  );
};

export default EditWaitlist;
